import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { Divider, Heading, OnboardingStep } from "../../components";
import Modal from "../../components/core/Modal";
import { ContentContainer, PageContainer, TaskList } from "../../containers";
import { useOnboardingUser } from "../../hooks";
import { ONBOARDING_STATUS, ONBOARDING_STATUS_INDEX, STEPS_STATUS } from "../../constants/constants";
import actions from "../../config/content/onboarding-todo";
import steps from "../../config/content/onboarding-progress-steps";
import { useDocumentTitle } from "../../hooks/useDocumentTitle";
import LoaderPage from "../utility/LoaderPage";

export default function Dashboard() {
  useDocumentTitle("Dashboard");

  const { user, isOnboardingTaskCompleted } = useOnboardingUser();
  const [currentStepIdx, setCurrentStepIdx] = useState([null]);
  const [, setOnboardingStepsState] = useState([]);
  const [onboardingTasks, setOnboardingTasks] = useState([]);
  const [mobileStepExpand] = useState(false);
  const [onboardingSteps, matchTutor] = steps;
  const [showTutorPortalModal, setShowTutorPortalModal] = useState(false);

  useEffect(() => {
    if (!user) return;
    setCurrentStepIdx(ONBOARDING_STATUS_INDEX[user.status]);
    
    // Show modal if user is matched or ready to tutor
    if (user.status === ONBOARDING_STATUS.MATCHED || user.status === ONBOARDING_STATUS.TUTOR_READY) {
      setShowTutorPortalModal(true);
    }
  }, [user]);

  useEffect(() => {
    if (currentStepIdx === null || !steps) return;
    const userSteps = _.map(steps, (step, idx) => {
      step.idx = idx;
      if (currentStepIdx === idx) {
        step.status = STEPS_STATUS.CURRENT;
      } else if (currentStepIdx > idx) {
        step.status = STEPS_STATUS.COMPLETE;
      } else {
        step.status = STEPS_STATUS.PENDING;
      }
      return step;
    });
    setOnboardingStepsState(userSteps);
  }, [currentStepIdx]);

  useEffect(() => {
    if (!user || !actions) return;
    const userTasks = _.map(actions, (action) => ({
      ...action,
      isCompleted: isOnboardingTaskCompleted(action.name),
    }));
    console.log(userTasks);
    setOnboardingTasks(userTasks);
  }, [user, isOnboardingTaskCompleted]);


  if (!user) {
    return <LoaderPage />;
  } else if (user.interviewDate === null) {
    return <Navigate to="/onboarding/chat/schedule" replace />;
  } else {
    return (
      <>
        {showTutorPortalModal && (
          <Modal title="🎉 Onboarding complete!" close={() => setShowTutorPortalModal(false)}>
            <div className="flex flex-col">
              <span className="mt-2 text-lg">From here on out, everything happens in the Tutor Portal.</span>
              <ul className="list-disc pl-5 mt-4">
                <li className="mb-2">Look for the "Welcome to the Tutor Portal" message we sent to your personal email—it has your temporary login.</li>
                <li className="mb-2">Hit "Reset password," choose a new one, and you're good to go.</li>
                <li className="mb-2">Sign in with your Step Up email.</li>
              </ul>
              <div className="text-center mt-4">
                <Link to="/tutoring" className="text-turquoise hover:text-turquoise-dark font-medium text-lg">
                  See you inside!
                </Link>
              </div>
            </div>
          </Modal>
        )}
        <PageContainer className="p-12 sm:pt-2">
          <ContentContainer>
            {/* desktop version of welcoming messages */}
            <div className="hidden sm:block">
              <Heading>Welcome to the Onboarding Portal, {user.firstname} 👋 </Heading>
              <p>
                We're glad you're here! This portal has everything you need to onboard. Complete the items as soon as
                you can, so we can get you matched with a student. No need to complete these steps in any particular
                order.
              </p>
            </div>
            {/* mobile version of welcoming messages */}
            <div className="sm:hidden">
              <Heading>Welcome {user.firstname}! 👋</Heading>
              <p>We're glad you're here!</p>
            </div>
          </ContentContainer>

          <Divider size="small" />

          <ContentContainer>
            {/* Onboarding Steps */}
            {/* start - mobile version only */}
            <div className="sm:hidden">
              <OnboardingStep step={onboardingSteps} steps={steps}>
                {mobileStepExpand === false ? (
                  <TaskList items={onboardingTasks.slice(0, 5)} pad="4" />
                ) : (
                  <TaskList items={onboardingTasks.slice(0, 5)} />
                )}
              </OnboardingStep>
            </div>
            {/* end - mobile version only */}
            
            {/* start - desktop version only */}
            <div className="pt-8 flex hidden sm:flex">
              <OnboardingStep step={onboardingSteps} steps={steps}>
                <TaskList items={onboardingTasks.slice(0, 5)} />
              </OnboardingStep>
            </div>

            {/* end - desktop version only */}

            {/* Match with a student */}

            <OnboardingStep
              step={matchTutor}
              steps={steps}
              text="We will take it from here! We utilize your application date to..."></OnboardingStep>
          </ContentContainer>
        </PageContainer>
      </>
    );
  }
}
